"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const MailOutline = _ref => {
  let {
    title = 'Mail',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 15.344l10.688-6.688h-21.375zM26.688 24.656v-13.313l-10.688 6.625-10.688-6.625v13.313h21.375zM26.688 5.969q1.063 0 1.844 0.813t0.781 1.875v16q0 1.094-0.766 1.891t-1.859 0.797h-21.375q-1.063 0-1.844-0.797t-0.781-1.891v-16q0-1.063 0.766-1.875t1.859-0.813h21.375z"
  }));
};
var _default = exports.default = (0, _ikon.default)(MailOutline);
MailOutline.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MailOutline",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Mail'",
        "computed": false
      },
      "required": false
    }
  }
};